import { FC, ReactNode } from 'react';
import storyCss from '../assets/story-item.module.scss';

type PropsType = {
  description: ReactNode;
};

const StoryItemDescription: FC<PropsType> = ({
  description,
}) => (
  <div className={storyCss.storyItem__description}>
    {description}
  </div>
);

export { StoryItemDescription };
